const TriviaApi = {
  url: 'https://opentdb.com/api.php?amount=10&type=multiple&encode=url3986',
  category: 'https://opentdb.com/api_category.php',
  token: 'https://opentdb.com/api_token.php?command=request'
};

export default TriviaApi;
